


















import { getPaginatedEntries } from '@bkwld/cloak/services/craft.coffee'
import getPaginatedEntriesQuery from '~/queries/get-paginated-entries.gql'
import NewsCard from '/components/globals/cards/news'

export default

	props: block: Object

	components: { NewsCard }

	data: ->
		entries: []
		hasMore: false
		page: 0
		pagination: '6'


	# Fetch entries
	fetch: ->

		{ entries: newEntries, hasMore } =  await getPaginatedEntries
			query: getPaginatedEntriesQuery
			variables:
				section: 'news'
				type: 'news'
				limit: parseInt @pagination
				offset: @page * @pagination
				nextOffset: (@page + 1) * @pagination

		@entries = [ ...@entries, ...newEntries ]
		@hasMore = !!hasMore

	watch:

		# watch the page and query for more entries
		page: -> @$fetch()


